import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ConfirmationDialogComponent } from './component/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogDirective } from './component/confirmation-dialog/confirmation-dialog.directive';
import { SpinnerComponent } from './component/spinner/spinner.component';
import { ScrollMeDirective } from './directive/scroll-me/scroll-me.directive';
import { DropdownSearcherComponent } from './component/dropdown-searcher/dropdown-searcher.component';
import { ProgressBarComponent } from './component/progress-bar/progress-bar.component';
import { FileSizePipe } from './pipe/file-size.pipe';
import { NotificationsComponent } from './component/notifications/notifications.component';
import { GoogleChartDirective } from './component/google-chart/google-chart.component';
import { CampaignUtilModule } from '../../module/campaign-util/campaign-util.module';
import { NumberPickerComponent } from './component/number-picker/number-picker.component';
import { IconComponent } from './component/icons/icon.component';
import { HolderDirective } from './directive/holder/holder.directive';
import { LoaderComponent } from './component/loader/loader.component';
import { PasswordStrengthMeterComponent } from './component/password-strength-meter/password-strength-meter.component';
import { UnsavedChangesDialogComponent } from './component/unsaved-changes-dialog/unsaved-changes-dialog.component';
import { TooltipComponent } from './component/tooltip/tooltip.component';
import { ClipboardModule } from 'ngx-clipboard';
import { PhotocodeComponent } from './component/photocode/photocode.component';
import { RouterModule } from '@angular/router';
import { VatPipe } from './pipe/vat.pipe';
import { NetPipe } from './pipe/net.pipe';
import { TimePickerComponent } from './component/time-picker/time-picker.component';
import { PhoneFormatDirective } from './directive/phone/phone.directive';

@NgModule({
    declarations: [
        TimePickerComponent,
        ConfirmationDialogComponent,
        ConfirmationDialogDirective,
        SpinnerComponent,
        ScrollMeDirective,
        DropdownSearcherComponent,
        ProgressBarComponent,
        FileSizePipe,
        VatPipe,
        NetPipe,
        NotificationsComponent,
        GoogleChartDirective,
        NumberPickerComponent,
        IconComponent,
        HolderDirective,
        LoaderComponent,
        PasswordStrengthMeterComponent,
        UnsavedChangesDialogComponent,
        TooltipComponent,
        PhotocodeComponent,
        PhoneFormatDirective,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ModalModule,
        TooltipModule,
        ReactiveFormsModule,
        CampaignUtilModule,
        BsDatepickerModule.forRoot(),
        TooltipModule.forRoot(),
        ClipboardModule,
        RouterModule,
    ],
    exports: [
        ConfirmationDialogComponent,
        ConfirmationDialogDirective,
        SpinnerComponent,
        ScrollMeDirective,
        DropdownSearcherComponent,
        ProgressBarComponent,
        FileSizePipe,
        NetPipe,
        VatPipe,
        TooltipModule,
        BsDatepickerModule,
        NotificationsComponent,
        GoogleChartDirective,
        NumberPickerComponent,
        IconComponent,
        HolderDirective,
        LoaderComponent,
        PasswordStrengthMeterComponent,
        UnsavedChangesDialogComponent,
        TooltipComponent,
        PhotocodeComponent,
        TimePickerComponent,
        PhoneFormatDirective,
    ],
    entryComponents: [ConfirmationDialogComponent, UnsavedChangesDialogComponent],
})
export class UiModule {}
